import Lottie from 'react-lottie';

const LottieImage = ({ animationData, height, width, ...props }) => {
  return (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      height={height}
      width={width}
      {...props}
      style={{ margin: 0, ...props.style }}
    />
  );
};

export default LottieImage;
